<template>
    <div class="demo-image__preview">
        <el-image :src="imageurl[0]" :zoom-rate="1.2" :max-scale="7" :min-scale="0.2"
            :preview-src-list="imageurl" :initial-index="0" fit="cover">

            <template #loading>
                <div class="loading-overlay">
                    <i class="el-icon-loading"></i>
                </div>
            </template>

            <template #error>
                <div class="image-slot">
                    <el-icon><icon-picture /></el-icon>
                </div>
            </template>
        </el-image>
    </div>
</template>

<script>
import { Picture as IconPicture } from '@element-plus/icons-vue'

export default {
    props: {
        imageurl: {
            type: Array,
            default: [],
        }
    },

    data() {
        return {
            url: 'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
            srcList: [
                this.imageurl
            ]
        }
    },
    components: {
        IconPicture
    }
}


</script>

<style scoped>
.image-slot .el-icon {
    font-size: 35px;
}

.el-image {
    width: 100%;
    height: 100%;
    opacity: 0;
    animation: mymove 0.6s ease-in forwards;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 480px;
    height: 520px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f0f0f0;
}

.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 480px;
    height: 520px;
    background: var(--el-fill-color-light);
    color: var(--el-text-color-secondary);
    font-size: 35px;
}

@keyframes mymove {
    10% {
        opacity: 0.1;
    }

    50% {
        opacity: 0.5;
    }

    60% {
        opacity: 0.6;
    }

    90% {
        opacity: 0.9;
    }

    100% {
        opacity: 1;
    }
}
</style>